export default "__VITE_ASSET__viCOv0U2__"